import { Heading, Img, Stack, Text, VStack } from '@chakra-ui/react';

import { PageContainer, PageContent } from 'components';
import { usePageTextContent } from 'context/pageTextContent';

export const ManagementSection = () => {
  const { content } = usePageTextContent<StoresPageContent>();

  const { title, description, pictureUrl } = content.management;

  return (
    <PageContainer>
      <PageContent>
        <Stack
          direction={['column', 'column', 'row', 'row']}
          w="full"
          spacing="2.5rem"
          align={['center', 'center', 'center', 'flex-end']}
        >
          <VStack align="flex-start" spacing="5rem">
            <VStack align="flex-start" spacing="1rem">
              <Heading fontSize="1.5rem" whiteSpace="pre-line">
                {title}
              </Heading>
              <Text fontSize="1.125rem" style={{ columns: '15.75rem auto' }}>
                {description}
              </Text>
            </VStack>
          </VStack>

          <Img
            src={pictureUrl}
            w={['full', 'full', '40%', 'full']}
            maxW="39rem"
            rounded="lg"
            shadow="xl"
            alt="Retailer Backoffice"
            loading="lazy"
          />
        </Stack>
      </PageContent>
    </PageContainer>
  );
};
